export { default as Hyperlink } from './Hyperlink';
import Hyperlink from './Hyperlink';

export default Hyperlink;
